module.exports = __webpack_public_path__ + "static/src/content/images/vega magick.26df7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/vega magick.png
// module id = w2CL
// module chunks = 0